import {
    Anchor,
    Button,
    Checkbox,
    Container,
    Divider,
    Flex,
    Paper,
    PasswordInput,
    Space,
    Stack,
    Text,
    TextInput,
} from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import { isEmail, isNotEmpty, matchesField, useForm } from '@mantine/form';

import HCaptcha from '@hcaptcha/react-hcaptcha';
import useSignup from '../../../http/mutations/auth/useSignup';

const Signup = ({ ...props }) => {
    const navigate = useNavigate();
    const { isPending, mutate: signup } = useSignup();
    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            username: '',
            password: '',
            confirmPassword: '',
            terms: true,
        },

        validate: {
            name: isNotEmpty,
            email: isEmail('Invalid email'),
            password: (val) =>
                val.length <= 8
                    ? 'Password should include at least 8 characters'
                    : null,
            confirmPassword: matchesField('password', 'Password must match'),
        },
    });

    const handleCaptcha = (token, ekey) => {
        form.setFieldValue('captchaResponse', token);
        form.setFieldValue('captchaSessionId', ekey);
    };

    const onSubmit = (model) => {
        signup(model, {
            onSuccess(data, variables, context) {
                navigate('/devices');
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    return (
        <Container
            size={'xs'}
            my={30}>
            <Flex
                align={'center'}
                justify={'center'}>
                <Paper
                    radius='md'
                    p='xl'
                    withBorder>
                    <Text
                        size='lg'
                        fw={500}>
                        Welcome to <strong>Reach</strong>SMS, sign-up with
                    </Text>

                    <Divider
                        label='Or continue with email'
                        labelPosition='center'
                        my='lg'
                    />

                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack>
                            <TextInput
                                label='Name'
                                placeholder='Your name'
                                value={form.values.name}
                                onChange={(event) =>
                                    form.setFieldValue(
                                        'name',
                                        event.currentTarget.value
                                    )
                                }
                                radius='md'
                                required
                                {...form.getInputProps('name')}
                            />

                            <TextInput
                                required
                                label='Username'
                                placeholder='Your username'
                                radius='md'
                                {...form.getInputProps('username')}
                            />

                            <TextInput
                                required
                                label='Email'
                                placeholder='me@reachsms.vip'
                                radius='md'
                                {...form.getInputProps('email')}
                            />

                            <PasswordInput
                                required
                                label='Password'
                                placeholder='Your password'
                                radius='md'
                                {...form.getInputProps('password')}
                            />

                            <PasswordInput
                                required
                                label='Confirm Password'
                                placeholder='Re-type password'
                                radius='md'
                                {...form.getInputProps('confirmPassword')}
                            />

                            <Checkbox
                                label='I accept terms and conditions'
                                checked={form.values.terms}
                                onChange={(event) =>
                                    form.setFieldValue(
                                        'terms',
                                        event.currentTarget.checked
                                    )
                                }
                            />

                            <>
                                <HCaptcha
                                    id={'signup-captcha'}
                                    sitekey={
                                        import.meta.env.VITE_APP_HCAPTCHA_KEY
                                    }
                                    onVerify={handleCaptcha}
                                />
                            </>
                        </Stack>

                        <Stack
                            justify='space-between'
                            align={'center'}
                            mt='md'>
                            <Button
                                type='submit'
                                radius='xl'
                                px='xl'
                                fullWidth
                                disabled={isPending}>
                                Sign up
                            </Button>
                            <Text
                                size='xs'
                                c='dimmed'>
                                Already have an account?{' '}
                                <Anchor
                                    to={'/auth/login'}
                                    component={Link}>
                                    Login
                                </Anchor>
                            </Text>
                        </Stack>
                    </form>
                </Paper>
            </Flex>
        </Container>
    );
};
export default Signup;
